var map = {
	"./HTML5.svg": 895,
	"./actix.svg": 896,
	"./aiohttp.svg": 897,
	"./amd.svg": 898,
	"./amixr.svg": 899,
	"./android.svg": 900,
	"./angularjs.svg": 901,
	"./app-engine.svg": 902,
	"./apple.svg": 903,
	"./asana.svg": 904,
	"./asayer.svg": 905,
	"./auth0.svg": 906,
	"./aws.svg": 907,
	"./awslamda.svg": 908,
	"./azure.svg": 909,
	"./backbone.svg": 910,
	"./bitbucket.svg": 911,
	"./bootstrap.svg": 912,
	"./bottle.svg": 913,
	"./campfire.svg": 914,
	"./celery.svg": 915,
	"./chalice.svg": 916,
	"./chrome.svg": 917,
	"./clickup.svg": 918,
	"./clojure.svg": 919,
	"./clubhouse.svg": 920,
	"./connect.svg": 921,
	"./cordova.svg": 922,
	"./csharp.svg": 923,
	"./dart.svg": 924,
	"./datadog.svg": 925,
	"./default.svg": 926,
	"./django.svg": 927,
	"./dotnet.svg": 928,
	"./dotnetcore.svg": 929,
	"./electron.svg": 930,
	"./elixir.svg": 931,
	"./ember.svg": 932,
	"./express.svg": 933,
	"./falcon.svg": 934,
	"./firetv.svg": 935,
	"./flask.svg": 936,
	"./flowdock.svg": 937,
	"./flutter.svg": 938,
	"./fsharp.svg": 939,
	"./fullstory.svg": 940,
	"./gcp.svg": 941,
	"./generic.svg": 942,
	"./github.svg": 943,
	"./gitlab.svg": 944,
	"./go.svg": 945,
	"./google.svg": 946,
	"./heroku.svg": 947,
	"./intellinote.svg": 948,
	"./ios.svg": 949,
	"./java.svg": 950,
	"./javascript.svg": 951,
	"./jira.svg": 952,
	"./koa.svg": 953,
	"./kotlin.svg": 954,
	"./laravel.svg": 955,
	"./lighthouse.svg": 956,
	"./linear.svg": 957,
	"./logback.svg": 958,
	"./msteams.svg": 959,
	"./nativec.svg": 960,
	"./net5.svg": 961,
	"./nodejs.svg": 962,
	"./okta.svg": 963,
	"./onelogin.svg": 964,
	"./opsgenie.svg": 965,
	"./pagerduty.svg": 966,
	"./perl.svg": 967,
	"./phabricator.svg": 968,
	"./php.svg": 969,
	"./pivotaltracker.svg": 970,
	"./pushover.svg": 971,
	"./pyramid.svg": 972,
	"./python.svg": 973,
	"./rails.svg": 974,
	"./react.svg": 975,
	"./redis.svg": 976,
	"./redmine.svg": 977,
	"./redux.svg": 978,
	"./relay.svg": 979,
	"./rippling.svg": 980,
	"./rocketchat.svg": 981,
	"./rookout.svg": 982,
	"./ruby.svg": 983,
	"./rust.svg": 984,
	"./saml2.svg": 985,
	"./segment.svg": 986,
	"./sentry.svg": 987,
	"./serverless.svg": 988,
	"./slack.svg": 989,
	"./split.svg": 990,
	"./spring.svg": 991,
	"./springboot.svg": 992,
	"./sprintly.svg": 993,
	"./swift.svg": 994,
	"./symfony.svg": 995,
	"./taiga.svg": 996,
	"./teamwork.svg": 997,
	"./tornado.svg": 998,
	"./trello.svg": 999,
	"./tryton.svg": 1000,
	"./twilio.svg": 1001,
	"./unity.svg": 1002,
	"./unreal.svg": 1003,
	"./vercel.svg": 1004,
	"./visualbasic.svg": 1005,
	"./vue.svg": 1006,
	"./windows.svg": 1007,
	"./youtrack.svg": 1008,
	"./zendesk.svg": 1009,
	"./zulip.svg": 1010
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1127;